module.exports = __webpack_public_path__ + "img/ab9ee564765885599d6caedece50d914.png";